import React, {Component} from 'react';
import Modal from 'react-bootstrap/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';



export default class Model extends Component{
    constructor(props) {
        super(props);
    }
    
    modeShow(show){
        this.props.modeShow(show);
    }

    finishTest(){
        this.props.EndExam(1);
    }
	
    render(){

        return(
            <div >
                <Modal className="submiteTestModel" show={this.props.show}  animation={true} >
                 
                <Modal.Body className="py-0 border">
                <FontAwesomeIcon size='3x'icon= {faExclamationTriangle}  style={{ color : "#ffc107", padding : "3px" }} />
                <p> <strong>Are you sure ?</strong></p>
                You will not be able to edit post submission.
                </Modal.Body>
                    <Modal.Footer className="py-1 d-flex justify-content-center">
                    <div>
                        <button variant="outline-danger" className="mx-2 px-3 btn btn-success" onClick={() => this.finishTest()}>Confirm</button>
                    </div>
                    <div>
                        <button variant="outline-dark" className="btn btn-danger" onClick={() => this.modeShow(false)}>Close</button>
                    </div>
                    
                    </Modal.Footer>
                </Modal>
            </div>
		);
    }
}